import FooterComp from '../components/footerComp';

const Footer = () => {
    return <FooterComp />;
};

export default Footer;
